import { createFileRoute } from '@tanstack/react-router';
import { FloorPage } from '@/features/office/floor-page';

export interface FloorSearch {
  /** `?via=portal` enters straight away: stairs from another floor brought the person here. */
  via?: 'portal';
  /** `?room=` walks into that room after entering: joining a meeting from the Planner or the inbox. */
  room?: string;
}

export const Route = createFileRoute('/w/$workspaceId/office/$floorId')({
  validateSearch: (search: Record<string, unknown>): FloorSearch => ({
    ...(search.via === 'portal' ? { via: 'portal' as const } : {}),
    ...(typeof search.room === 'string' && search.room ? { room: search.room } : {}),
  }),
  component: FloorRoute,
});

function FloorRoute() {
  const { floorId } = Route.useParams();
  const { via, room } = Route.useSearch();
  return <FloorPage key={floorId} floorId={floorId} autoEnter={via === 'portal'} arriveRoomId={room ?? null} />;
}
